import { Injectable, Inject } from '@angular/core'
import { Storage } from './storage'
import { STORAGE_PREFIX } from '../tokens'

@Injectable()
export class SessionStorage extends Storage {
  constructor(@Inject(STORAGE_PREFIX) storagePrefix) {
    super(sessionStorage, storagePrefix)
  }
}
